import { Card } from "@sainsburys-tech/luna-card";
import { Container } from "@sainsburys-tech/luna-grid";
import React, { FC, useEffect, useState } from "react";
import {
  IInitialStateDuType,
  iInitialStateDuType,
} from "../../../Interfaces/IDuType";
import DuTypeForm from "./duTypeForm";
import store from "../../../Store/store";
import { storeAddPayload } from "../../../Redux/Actions/popupActions";
import { useSelector } from "react-redux";
import { editTablePayload } from "../../../Redux/Actions/editTableActions";
import {
  validateContainerType,
  validateContainerName,
  validateField,
  validateForm,
} from "./duTypeValidations";
import { consolelog } from "../../../helpers/consolelog";
import { getData } from "../../../Service-Utils/autoCompleteHelper";
import { ERROR_MESSAGES, FIELDS } from "../../../Interfaces/IDuTypeFormField";
import LoadingIndicator from "../../Loading";

export interface DuTypeAddFormProps {
  closeModal: () => void;
  isEdit: boolean;
}

const DuTypeAddFormAdd: FC<DuTypeAddFormProps> = ({ closeModal, isEdit }) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [state, setState] = useState<IInitialStateDuType>(iInitialStateDuType);
  const [isLinkedAlready, setIsLinkedAlready] = useState<boolean>(false);
  const [isValidatingForm, setIsValidatingForm] = useState<boolean>(false);

  useEffect(() => {
    if (payload.data) {
      if (payload?.data?.editPayload?.values?.containerName === undefined) {
        setState(iInitialStateDuType);
      } else {
        setState(payload.data.editPayload);
      }
    } else {
      setState(iInitialStateDuType);
    }
  }, [payload]);

  useEffect(() => {
    const loadData = async () => {
      const containerType = payload?.data?.editPayload?.values?.containerType;
      const response = await getData(
        "dutypemaintenance/DuTypeMaintenances",
        `LinkedContainers/Any(k:k/LinkedContainerType eq '${containerType}')`,
        true,
        0,
        1,
        containerType
      );

      if (response.length > 0) {
        setIsLinkedAlready(true);
      }
    };

    loadData();
  }, []);

  /*Events of form*/
  const handleBlur = (target: any) => {
    const { values, errors } = state;

    const fieldName = target.name || target.id;
    const valid = validateField(
      fieldName,
      values[fieldName as keyof typeof values],
      values,
      isLinkedAlready
    );

    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        dirty: true,
        isFormValid: valid.result,
      };
    });

    if (target.name === "containerType") {
      validateContainerType(
        fieldName,
        values[fieldName as keyof typeof values],
        values
      ).then((x) => {
        setState((initialState: IInitialStateDuType) => {
          return {
            ...initialState,
            errors: {
              ...errors,
              containerType: x.errorMsg || initialState.errors.containerType,
            },
            dirty: true,
            isFormValid: x.result,
          };
        });
      });
    }

    if (target.name === "containerName") {
      validateContainerName(
        fieldName,
        values[fieldName as keyof typeof values],
        values
      ).then((x) => {
        setState((initialState: IInitialStateDuType) => {
          return {
            ...initialState,
            errors: {
              ...errors,
              containerName: x.errorMsg || initialState.errors.containerName,
            },
            dirty: true,
            isFormValid: x.result,
          };
        });
      });
    }
  };

  const handleChange = (target: any) => {
    let targetValue: any;

    switch (target.type) {
      case "checkbox": {
        targetValue = target.checked;
        break;
      }
      default: {
        targetValue = target.value;
      }
    }

    // if(target.name==="containerType"){
    //   //dispatch data
    //   const searchPayloadData = {
    //     apiPath: "dutypemaintenance/DuTypeMaintenances",
    //     enabled: true,
    //     filter:`ContainerType eq '${targetValue}'`,
    //     value:targetValue,
    //     key: new Date().toISOString()
    //   };
    //   store.dispatch(searchPayload(searchPayloadData));
    // }

    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        values: { ...values, [target.name]: targetValue },
        dirty: true,
      };
    });
  };
  const handleLegacy = (value: any) => {
    let targetValue: any;

    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        values: { ...values, ["legacyContainerDetails"]: value },
        dirty: true,
      };
    });
  };

  const handleLinkedContainerUpdate = (value: any) => {
    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        values: { ...values, ["linkedContainers"]: value },
        dirty: true,
      };
    });

    let isMLPInValid =
      value == null || value == undefined || value?.length <= 0;

    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        errors: {
          ...errors,
          [FIELDS.mlpIndicator.name]: isMLPInValid
            ? ERROR_MESSAGES.mlpIndicator
            : "",
        },
        dirty: true,
        isFormValid: !isMLPInValid,
      };
    });
  };

  const handleSubmit = async (e: any) => {
    const { values } = state;
    e.preventDefault();

    setIsValidatingForm(true);
    const valid = await validateForm(values, isEdit, isLinkedAlready);
    setIsValidatingForm(false);

    setState((initialState: IInitialStateDuType) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        submitted: valid.result,
      };
    });

    if (!valid.result) {
      setTimeout(scrollToError, 100);
      return;
    }

    const duTypePayload = {
      ContainerType: values.containerType,
      ContainerName: values.containerName,
      Description: values.description,
      //CustomerType: values.customerType,
      LegacyContainerDetails: values.legacyContainerDetails ?? [],
      Weight: values.weight,
      Volume: values.volume,
      FullLength: values.fullLength,
      FullWidth: values.fullWidth,
      FullHeight: values.fullHeight,
      WeightCap: values.weightCap,
      MinPickVolume: values.minPickVolume,
      MaxPickVolume: values.maxPickVolume,
      LpIndicator: values.lpIndicator ? true : false,
      MlpIndicator: values.mlpIndicator ? true : false,
      MuIndicator: values.muIndicator ? true : false,
      IsLinkableContainer: values.isLinkableContainer ? true : false,
      LinkedContainers: values.mlpIndicator ? values.linkedContainers : [],
      //Source: UI_CONSTANTS.LDMUI,
    };

    if (isEdit) {
      const editPayload = {
        Id: payload.data.id,
        ...duTypePayload,
      };

      store.dispatch(editTablePayload(editPayload));
    } else {
      store.dispatch(storeAddPayload({ addPayload: duTypePayload }));
    }

    closeModal();
  };
  const clearAll = (e: any) => {
    if (isEdit) {
      consolelog("edit mode");
      setState(payload.data.editPayload);
    } else {
      setState(iInitialStateDuType);
    }
  };
  const scrollToError = () => {
    const firstError = document.querySelector(
      ".ln-c-form-group.has-error"
    ) as HTMLElement | null;
    if (firstError) {
      window.scrollTo(0, firstError.offsetTop);
      const inputField = firstError.querySelector(
        "input"
      ) as HTMLElement | null;
      inputField?.focus();
    }
  };
  /*Events of form*/

  const { values, errors, submitted, dirty, isFormValid } = state;

  return (
    <>
      <h4 className="duTypeModal-heading">
        {isEdit ? "Edit" : "Create New"} Container Type
      </h4>
        <DuTypeForm
          values={values}
          id={payload.data.id}
          onBlur={(event) => handleBlur(event.target)}
          onChange={(event) => handleChange(event.target)}
          onSubmit={(event) => handleSubmit(event)}
          onClearAll={(event) => clearAll(event)}
          onLegacyContainer={(event) => handleLegacy(event)}
          onLinkedContainerUpdate={(event) =>
            handleLinkedContainerUpdate(event)
          }
          onCancel={closeModal}
          errors={errors}
          dirty={dirty}
          submitted={submitted}
          isEdit={isEdit}
          isFormValid={isFormValid}
        />
      {isValidatingForm && <LoadingIndicator />}
    </>
  );
};

export default DuTypeAddFormAdd;
